export const imageLoad = (url) => {
    return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
            resolve(img);
        };
        img.onerror = function () {
            resolve(false);
        };
        img.src = url;
    });
};
